<template>
  <div class="div1">
    <mu-appbar style="width: 100%;height:40px;" color="red" v-show="!openFullscreen && !openUpdateDialog && !openSearchDialog">
      <mu-button icon slot="left" @click="toHome"  style="font-size: 12px;width:40px;margin: 0;">
        <mu-icon value="home"></mu-icon>
      </mu-button>
      <span style="font-size: 14px;"><mu-chip class="demo-chip" color="blue200" delete @delete="logout" style="height:22px; vertical-align:middle;">
          <mu-icon value="person"/><span style="font-size: 10px;">{{username}}</span>
        </mu-chip></span>
      <span style="font-size: 14px;">出库操作</span>

      <!--<mu-button flat slot="right"  small @click="insert_click" style="font-size: 12px;width:40px;margin: 0;"><mu-icon value="add" ></mu-icon></mu-button> -->
      <mu-button flat slot="right"  small  @click="search_click" style="font-size: 12px;width:40px;margin: 0;"><mu-icon value="search" ></mu-icon></mu-button>

    </mu-appbar>

    <mu-paper :z-depth="5" style="width: 100%;min-height:40px;margin: 0;padding: 10px;background-color: rgba(222, 222, 222, .5)" v-show="!openFullscreen && !openUpdateDialog && !openSearchDialog">
      <span slot="right" style="font-size: 10px;"><span style="font-size: 9px;">当前 / 总数 ：</span>
        <span style="width: 10px;color: red;font-size: 12px;" slot="right">{{search_total_count}} / {{total_count}}</span>

        <template v-if="searchMap.in_stock_type != ''">
            <mu-chip class="demo-chip" color="blue200"  delete @delete="serach_key_delete('in_stock_type')" style="height:22px; vertical-align:middle;">
              <mu-avatar text-color="blue300" color="indigo900" :size="28"><span style="font-size: 9px;">品种</span></mu-avatar> <span style="font-size: 10px;">{{searchMap.in_stock_type}}</span>
            </mu-chip>
        </template>
         <template v-if="searchMap.in_stock_model != ''">
            <mu-chip class="demo-chip" color="blue200"  delete @delete="serach_key_delete('in_stock_model')" style="height:22px; vertical-align:middle;">
              <mu-avatar text-color="blue300" color="indigo900" :size="28"><span style="font-size: 9px;">规格</span></mu-avatar> <span style="font-size: 10px;">{{searchMap.in_stock_model}}</span>
            </mu-chip>
        </template>

         <template v-if="searchMap.in_stock_from != ''">
            <mu-chip class="demo-chip" color="blue200"  delete @delete="serach_key_delete('in_stock_from')" style="height:22px; vertical-align:middle;">
              <mu-avatar text-color="blue300" color="indigo900" :size="28"><span style="font-size: 9px;">来源</span></mu-avatar> <span style="font-size: 10px;">{{searchMap.in_stock_from}}</span>
            </mu-chip>
        </template>

         <template v-if="searchMap.out_stock_date_start != '' || searchMap.out_stock_date_end != ''">
            <mu-chip class="demo-chip" color="blue200"  delete @delete="serach_key_delete('out_stock_date')" style="height:22px; vertical-align:middle;">
              <mu-avatar text-color="blue300" color="indigo900" :size="28"><span style="font-size: 9px;">时间</span></mu-avatar>
              <span style="font-size: 10px;">
                <template v-if="searchMap.out_stock_date_start != ''">{{search_out_stock_date_start_computed}}</template>
                to
                <template v-if="searchMap.out_stock_date_end != ''">{{search_out_stock_date_end_computed}}</template>
              </span>
            </mu-chip>
        </template>
      </span>
      <span style="float: right" v-if="search_total_count > 0"><van-button type="danger" size="mini" @click="exportExcel_click()">导出Excel</van-button></span>
    </mu-paper>


    <mu-load-more ref="lm" @refresh="refresh" :refreshing="refreshing" :loading="loading" @load="load" style="width: 100%" v-show="!openFullscreen && !openUpdateDialog && !openSearchDialog" class="demo-loadmore-content">
          <mu-list style="width:100%;padding:0;margin:0;border: 0px solid #000;background-color: rgba(222, 222, 222, .5)">
            <template v-for="(item,index) in list">

              <template v-if="index == 0">
                <mu-row style="border: 0px solid #f00;">
                  <mu-col span="12" style="padding: 4px;text-align: center">
                    <span style="font-size: 14px;font-weight:bold; color: rgba(150,125,125,.8)" >{{item.out_stock_date_f}}</span>
                  </mu-col>
                </mu-row>
              </template>
              <template v-if="index != 0 && item.out_stock_date_f != list[index - 1].out_stock_date_f">
                <mu-row style="border: 0px solid #f00;">
                  <mu-col span="12" style="padding: 4px;text-align: center">
                    <span style="font-size: 14px;font-weight:bold; color: rgba(150,125,125,.8)" >{{item.out_stock_date_f}}</span>
                  </mu-col>
                </mu-row>
              </template>

              <mu-paper class="demo-paper" :z-depth="0" style="width:100%;padding:0;margin: 0;border: 0px solid #000;">
                <mu-expansion-panel :z-depth="0" style="width:100%;border: 0px solid #000;margin:0 auto 6px;">
                  <div slot="header" style="border: 0px solid #000;width:95%;padding: 5px 0;">

                    <mu-row style="border: 0px solid #f00;">
                      <mu-col span="12">
                        <span class="s_key">{{index + 1}}.</span>
                        <span style="font-size : 16px;font-weight: bolder;">{{item.in_stock_type}}</span>
                        &nbsp;&nbsp; <span style="font-size : 16px;font-weight: bolder;">{{item.in_stock_model}}</span><span class="s_key">ML</span>
                        &nbsp;&nbsp;{{item.in_stock_production_date}}<span v-if="item.in_stock_production_date" class="s_key">年份</span>
                      </mu-col>
                      <mu-col span="12">
                        <span class="s_key">数量:</span><span class="s1">{{item.out_stock_quantity}}</span> &nbsp;
                        &nbsp;&nbsp;<span class="s_key">单价: </span><span class="s1">¥{{item.out_stock_unit_price}}</span>
                        &nbsp;&nbsp;<span class="s_key">总价:</span><span class="s1">¥{{item.out_stock_total_price}}</span>
                      </mu-col>
                      <mu-col span="12">
                        <span class="s_key">出库时间:</span><span class="s1">{{item.out_stock_date_f.replace(STORE.cuur_year,"")}}</span> &nbsp;&nbsp; <span class="s_key">卖出平台:</span><span class="s1">{{item.out_stock_platform}}</span>
                      </mu-col>
                    </mu-row>

                  </div>

                  <div style="border: 0px solid #000;vertical-align: center;line-height: 25px;margin: 0;padding: 0">
                    <van-button type="danger" size="mini" icon="edit" @click="update(index)">修改</van-button>

                    <template v-for="(history_item,history_index) in item.history">
                      <template v-if="history_index == item.history.length - 1">
                        <van-tag mark plain size="mini" color="rgba(150, 0, 0, .5)">{{history_item.out_stock_history_update_date_f.replace(STORE.cuur_year,"")}}{{history_item.user_name}}</van-tag>
                      </template>
                      <template v-else>
                        <van-tag plain size="mini">{{history_item.out_stock_history_update_date_f.replace(STORE.cuur_year,"")}}{{history_item.user_name}}</van-tag>
                      </template>
                    </template>
                  </div>

                </mu-expansion-panel>
              </mu-paper>

              <template v-if="index == search_total_count - 1">
                <mu-paper class="demo-paper" :z-depth="0" style="border: 0px solid #0f0; width:100%;padding: 0;margin:0;">
                  <mu-container style="border: 0px solid #f00;vertical-align: center;text-align: center;">
                    <mu-row gutter>
                      <mu-col span="12">
                        <span style="font-size: 8px;font-weight:bold; color: rgba(150,125,125,.8)" >------------ 已 经 到 底 -------------</span>
                      </mu-col>
                    </mu-row>
                  </mu-container>
                </mu-paper>
              </template>

            </template>
          </mu-list>
        </mu-load-more>


    <mu-container width="100%" v-show="openFullscreen" height="100%">
      <mu-appbar  title="添加出库信息">
        <mu-button slot="left" icon @click="openFullscreen = false">
          <mu-icon value="close"></mu-icon>
        </mu-button>
        <mu-button slot="right" flat  @click="openFullscreen = false">
          取消
        </mu-button>
      </mu-appbar>
      <div style="padding: 24px;">
        <mu-form ref="form" :model="form" class="mu-demo-form" label-position="left" label-width="100">
          <mu-form-item prop="out_stock_type" label="*品种">
            <mu-text-field v-model="form.out_stock_type"></mu-text-field>
          </mu-form-item>
          <mu-form-item prop="out_stock_model" label="*规格">
            <mu-text-field v-model="form.out_stock_model"></mu-text-field>
          </mu-form-item>
          <mu-form-item prop="out_stock_production_date" label="年份">
            <mu-text-field v-model="form.out_stock_production_date"></mu-text-field>
          </mu-form-item>
          <mu-form-item prop="out_stock_quantity" label="*数量">
            <mu-text-field v-model="form.out_stock_quantity"></mu-text-field>
          </mu-form-item>
          <mu-form-item prop="out_stock_date" label="*入库时间">
            <mu-text-field v-model="form.out_stock_date"></mu-text-field>
          </mu-form-item>
          <mu-form-item prop="out_stock_from" label="*来源">
            <mu-text-field v-model="form.out_stock_from"></mu-text-field>
          </mu-form-item>
          <mu-form-item prop="out_stock_platform" label="*卖出平台">
            <mu-text-field v-model="form.out_stock_platform"></mu-text-field>
          </mu-form-item>
          <mu-form-item prop="out_stock_unit_price" label="*单价">
            <mu-text-field v-model="form.out_stock_unit_price"></mu-text-field>
          </mu-form-item>
          <mu-form-item prop="out_stock_total_price" label="总价">
            <mu-text-field v-model="form.out_stock_total_price"></mu-text-field>
          </mu-form-item>
        </mu-form>

        <mu-button color="primary" @click="submit">保存</mu-button>
        <mu-button @click="clear">重置</mu-button>

      </div>
    </mu-container>

    <mu-container width="100%" v-show="openUpdateDialog" height="100%">
      <mu-appbar  title="修改出库信息">
        <mu-button slot="left" icon @click="openUpdateDialog = false">
          <mu-icon value="close"></mu-icon>
        </mu-button>
        <mu-button slot="right" flat  @click="openUpdateDialog = false">
          取消
        </mu-button>
      </mu-appbar>
      <div style="padding: 10px;">
        <mu-form ref="form_update" :model="form_update" class="mu-demo-form" label-position="left" label-width="100">
          <mu-paper class="demo-paper" :z-depth="1" style=" width:99%;padding: 6px;margin: 12px   auto;">
            <mu-row style="border: 0px solid #f00;">
              <mu-col span="12">
                <span style="font-size : 16px;font-weight: bolder;">{{form_update.in_stock_type}}</span>
                &nbsp;&nbsp; <span style="font-size : 16px;font-weight: bolder;">{{form_update.in_stock_model}}</span><span class="s_key">ML</span>
                &nbsp;&nbsp;{{form_update.in_stock_production_date}}<span v-if="form_update.in_stock_production_date" class="s_key">年份</span>
              </mu-col>
              <mu-col span="12">
                <span class="s_key">数量:</span><span class="s1">{{form_update.in_stock_quantity}}</span> &nbsp;
                &nbsp;&nbsp;<span class="s_key">单价: </span><span class="s1">¥{{form_update.in_stock_unit_price}}</span>
                &nbsp;&nbsp;<span class="s_key">总价:</span><span class="s1">¥{{form_update.in_stock_total_price}}</span>
              </mu-col>
              <mu-col span="12">
                <span class="s_key">入库时间:</span><span class="s1">{{form_update.in_stock_date_f.replace(STORE.cuur_year,"")}}</span> &nbsp;&nbsp; <span class="s_key">来源:</span><span class="s1">{{form_update.in_stock_from}}</span>
              </mu-col>
            </mu-row>

          </mu-paper>

          <mu-form-item prop="out_stock_platform" label="*卖出平台">
            <mu-text-field v-model="form_update.out_stock_platform"></mu-text-field>
          </mu-form-item>
          <mu-form-item prop="out_stock_date" label="*出库时间">
            <mu-date-input type="date" actions v-model="form_update.out_stock_date" container="bottomSheet" label-float
                           full-width></mu-date-input>
          </mu-form-item>
          <mu-form-item prop="out_stock_quantity" label="*卖出数量">
            <mu-text-field v-model="form_update.out_stock_quantity"></mu-text-field>
          </mu-form-item>
          <mu-form-item prop="out_stock_unit_price" label="*单价">
            <mu-text-field v-model="form_update.out_stock_unit_price" prefix="¥"></mu-text-field>
          </mu-form-item>
          <mu-form-item prop="out_stock_total_price" label="*总价">
            ¥{{ update_out_stock_total_price_computed }}
          </mu-form-item>
        </mu-form>

        <mu-button color="red" full-width @click="submit_update">修改出库</mu-button>

      </div>
    </mu-container>

    <mu-container width="100%" v-show="openSearchDialog" height="100%">
      <mu-appbar  title="出库搜索">
        <mu-button slot="left" icon @click="openSearchDialog = false">
          <mu-icon value="close"></mu-icon>
        </mu-button>
        <mu-button slot="right" flat  @click="openSearchDialog = false">
          取消
        </mu-button>
      </mu-appbar>
      <div style="padding: 24px;">
        <mu-form ref="new_searchMap" :model="form" class="mu-demo-form" label-position="left" label-width="100">
          <mu-form-item prop="in_stock_type" label="品种">
            <mu-auto-complete :data="STORE.in_stock_type_all" :max-search-results="10" v-model="new_searchMap.in_stock_type"
                              open-on-focus></mu-auto-complete>
          </mu-form-item>
          <mu-form-item prop="in_stock_model" label="规格">
            <mu-text-field v-model="new_searchMap.in_stock_model"></mu-text-field>
          </mu-form-item>
          <mu-form-item prop="out_stock_date_start" label="出库时间起">
                  <mu-date-input type="date" actions v-model="new_searchMap.out_stock_date_start"  container="bottomSheet" full-width label-float
                                 :action-icon="true ? 'delete' : 'delete'" :action-click="() => (new_searchMap.out_stock_date_start = '')"/>
          </mu-form-item>
          <mu-form-item prop="out_stock_date_end" label="出库时间止">
                  <mu-date-input type="date" actions v-model="new_searchMap.out_stock_date_end"  container="bottomSheet" full-width label-float
                                 :action-icon="true ? 'delete' : 'delete'" :action-click="() => (new_searchMap.out_stock_date_end = '')"/>
          </mu-form-item>
          <mu-form-item prop="in_stock_from" label="来源">
            <mu-text-field v-model="new_searchMap.in_stock_from"></mu-text-field>
          </mu-form-item>
        </mu-form>

        <mu-button color="primary" full-width @click="submit_search">搜索</mu-button>

      </div>
    </mu-container>
  </div>

</template>

<script>
  import axios from 'axios'
  import Qs from 'qs'
  import Toast from 'muse-ui-toast';
  import Mj from '@/components/lib/Mj.js'
  import { Dialog } from 'vant';
  export default {
    created:function(){
      let _this = this;
      let loading = _this.$loading();
      let parms = {};
      Object.assign( parms , this.searchMap ,{begin:0});
      axios.post('/stock/out/select.mvc', Qs.stringify(parms))
        .then(function (response) {
          loading.close();
          //console.log("select.mvc response = "+JSON.stringify(response));
          if(response.data.status == "0"){
            Toast.error('没有数据！');
          }
          if(response.data.status == "2"){
            Toast.error('查询异常！');
          }
          if (response.data.status == "3") {
            Dialog.alert({
              title: '请重新登录',
              message: ''
            }).then(() => {
              _this.$router.replace("/Login");
            });
          }
          if(response.data.status == "1"){
            _this.list = response.data.data;
            _this.total_count = response.data.total_count;
            _this.search_total_count = response.data.search_total_count;
            _this.$refs.lm.loadedAll = _this.search_total_count > _this.list.length;
            Toast.success('OK！');
          }
        })
        .catch(function (error) {
          loading.close();
          console.log(error);
        });


    },
    data () {
      return {
        username : this.STORE.login.name,
        list : {},
        search_total_count : 0,
        total_count : 0,
        refreshing: false,
        loading: false,
        text: 'List',
        //loaded-all : false,
        openFullscreen: false,
        openSearchDialog: false,
        searchMap: {
          in_stock_type: '',
          in_stock_model:'',
          out_stock_date_start:'',
          out_stock_date_end:'',
          in_stock_from:''
        },
        new_searchMap: {
          in_stock_type: '',
          in_stock_model:'',
          out_stock_date_start:'',
          out_stock_date_end:'',
          in_stock_from:''
        },

        openUpdateDialog: false,
        form: {
          out_stock_type: '',
          out_stock_model:'',
          out_stock_production_date:'',
          out_stock_quantity:'',
          out_stock_date:'',
          out_stock_from:'',
          out_stock_platform:'',
          out_stock_unit_price:'',
          out_stock_total_price:''
        },
        form_update: {
          in_stock_id : '',
          in_stock_type: '',
          in_stock_model:'',
          in_stock_production_date:'',
          in_stock_quantity:'',
          in_stock_date_f:'',
          in_stock_from:'',
          in_stock_unit_price:'',
          in_stock_total_price:'',

          out_stock_quantity:'',
          out_stock_date:'',
          out_stock_platform:'',
          out_stock_unit_price:'',
          out_stock_total_price:''
        }
      }
    },
    computed: {
      update_out_stock_total_price_computed: function () {
        return Mj.toFix(this.form_update.out_stock_quantity * this.form_update.out_stock_unit_price, 2)
      },
      search_out_stock_date_start_computed: function () {
        let dt = this.searchMap.out_stock_date_start;
        let y = dt.getFullYear();
        let m = dt.getMonth() + 1;
        let d = dt.getDate();

        if(y = new Date().getFullYear()){
          return `${m}-${d}`;
        }else{
          return `${y}-${m}-${d}`;
        }
      },
      search_out_stock_date_end_computed: function () {
        let dt = this.searchMap.out_stock_date_end;
        let y = dt.getFullYear();
        let m = dt.getMonth() + 1;
        let d = dt.getDate();

        if(y = new Date().getFullYear()){
          return `${m}-${d}`;
        }else{
          return `${y}-${m}-${d}`;
        }
      }
    },
    methods: {
      toHome() {
        this.$router.replace("/Home");
      },
      logout() {
        let _this = this;
        let loading = _this.$loading();

        axios.post('/stock/logout.mvc', Qs.stringify({
          name: _this.STORE.login.name
        }))
          .then(function (response) {
            loading.close();
            console.log(response);
            if(response.data == "1"){
              _this.STORE.login.name = "";
              _this.$router.replace("/Login");
            }
          })
          .catch(function (error) {
            _this.STORE.login.name = "";
            loading.close();
            console.log(error);
          })
      },
      search_click () {
        Object.assign(this.new_searchMap, this.searchMap);
        //this.new_searchMap = this.searchMap;
        this.openSearchDialog = true;
      },
      serach_key_delete(t) {
        if (t == 'in_stock_type'){
          this.searchMap.in_stock_type = "";
          this.new_searchMap.in_stock_type = "";
        }
        if (t == 'in_stock_model'){
          this.searchMap.in_stock_model = "";
          this.new_searchMap.in_stock_model = "";
        }
        if (t == 'in_stock_from'){
          this.searchMap.in_stock_from = "";
          this.new_searchMap.in_stock_from = "";
        }
        if (t == 'out_stock_date'){
          this.searchMap.out_stock_date_start = "";
          this.new_searchMap.out_stock_date_start = "";
          this.searchMap.out_stock_date_end = "";
          this.new_searchMap.out_stock_date_end = "";
        }
        this.submit_search();
      },
      insert_click () {
        this.openFullscreen = true;
      },
      update(index){
        let item = this.list[index];
        this.form_update = item;
        this.openUpdateDialog = true;
      },
      refresh () {
        this.refreshing = true;
        //this.$refs.container.scrollTop = 0;
        let parms = {};
        let _this = this;
        Object.assign( parms , this.searchMap ,{begin:0});
        axios.post('/stock/out/select.mvc', Qs.stringify(parms))
          .then(function (response) {
            _this.refreshing = false;
            if(response.data.status == "0"){
              Toast.error('没有数据！');
            }
            if(response.data.status == "2"){
              Toast.error('查询异常！');
            }
            if (response.data.status == "3") {
              Dialog.alert({
                title: '请重新登录',
                message: ''
              }).then(() => {
                _this.$router.replace("/Login");
              });
            }
            if(response.data.status == "1"){
              _this.list = response.data.data;
              _this.total_count = response.data.total_count;
              _this.search_total_count = response.data.search_total_count;
              _this.$refs.lm.loadedAll = _this.search_total_count > _this.list.length;
              Toast.success('刷新完成！');
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      load () {
        let _this = this;
        _this.$refs.lm.loadedAll = _this.search_total_count > _this.list.length;
        if(_this.$refs.lm.loadedAll){
          this.loading = true;
          //console.error("insert ok-------" + _this.$refs.lm.loadedAll);
          let parms = {};
          Object.assign( parms , this.searchMap ,{begin:_this.list.length});
          axios.post('/stock/out/select.mvc', Qs.stringify(parms))
            .then(function (response) {
              _this.loading = false;
              _this.refreshing = false;
              if(response.data.status == "0"){
                Toast.error('没有数据！');
              }
              if(response.data.status == "2"){
                Toast.error('查询异常！');
              }
              if (response.data.status == "3") {
                Dialog.alert({
                  title: '请重新登录',
                  message: ''
                }).then(() => {
                  _this.$router.replace("/Login");
                });
              }
              if(response.data.status == "1"){
                _this.text = _this.text === 'List' ? 'Menu' : 'List';
                _this.list = _this.list.concat(response.data.data);
                _this.total_count = response.data.total_count;
                _this.search_total_count = response.data.search_total_count;
                _this.$refs.lm.loadedAll = _this.search_total_count > _this.list.length;
                //console.error("insert ok-------" + _this.$refs.lm.loadedAll);
                Toast.success('读取更多完成！');
              }
            })
            .catch(function (error) {
              this.loading = false;
              console.log(error);
            });
        }
      },
      submit () {
        let _this = this;
        this.$refs.form.validate().then((result) => {
          result?(axios.post('/stock/out/insert.mvc', Qs.stringify(_this.form))
            .then(function (response) {
              if(response.data.status == "1"){
                let parms = {};
                Object.assign( parms , this.searchMap ,{begin:0});
                axios.post('/stock/out/select.mvc',  Qs.stringify(parms))
                  .then(function (response) {
                    _this.openFullscreen = false;
                    if(response.data.status == "0"){
                      Toast.error('没有数据！');
                    }
                    if(response.data.status == "2"){
                      Toast.error('查询异常！');
                    }
                    if (response.data.status == "3") {
                      Dialog.alert({
                        title: '请重新登录',
                        message: ''
                      }).then(() => {
                        _this.$router.replace("/Login");
                      });
                    }
                    if(response.data.status == "1"){
                      _this.list = response.data.data;
                      _this.total_count = response.data.total_count;
                      _this.search_total_count = response.data.search_total_count;
                      _this.$refs.lm.loadedAll = _this.search_total_count > _this.list.length;
                    }
                  })
                  .catch(function (error) {
                    console.log(error);
                  });

              }
              if(response.data.status == "2"){
                Toast.error('插入数据异常！');
              }
            })
            .catch(function (error) {
              console.log(error);
            })):(null);
          // console.log('form valid: ', result);
        });
      },
      submit_update () {
        let _this = this;
        this.$refs.form_update.validate().then((result) => {
          //日期控件接受日期字符串和日期对象，提交时会使用UTC日期字符串。 后台输出日期对象， 接受本地日期字符串。 日期没有经过控件时，后台接受不了自己输出的日期对象
          //统一使用本地日期字符串
          _this.form_update.out_stock_date = new Date(_this.form_update.out_stock_date).toLocaleDateString();
          _this.form_update.out_stock_total_price = _this.update_out_stock_total_price_computed;
          //console.log("out_stock_date = "+JSON.stringify(_this.form_update.out_stock_date));
          result?(axios.post('/stock/out/update.mvc', Qs.stringify(_this.form_update))
            .then(function (response) {

              if(response.data.status == "1"){
                _this.openUpdateDialog = false;
                Toast.success('修改成功！');
                axios.post('/stock/out/select.mvc',  Qs.stringify(_this.searchMap))
                  .then(function (response) {
                    _this.openFullscreen = false;
                    if(response.data.status == "0"){
                      Toast.error('没有数据！');
                    }
                    if(response.data.status == "2"){
                      Toast.error('查询异常！');
                    }
                    if (response.data.status == "3") {
                      Dialog.alert({
                        title: '请重新登录',
                        message: ''
                      }).then(() => {
                        _this.$router.replace("/Login");
                      });
                    }
                    if(response.data.status == "1"){
                      _this.list = response.data.data;
                      _this.total_count = response.data.total_count;
                      _this.search_total_count = response.data.search_total_count;
                      _this.$refs.lm.loadedAll = _this.search_total_count > _this.list.length;
                    }
                  })
                  .catch(function (error) {
                    console.log(error);
                  });

              }
              if(response.data.status == "2"){
                Toast.error('插入数据异常！');
              }
            })
            .catch(function (error) {
              console.log(error);
            })):(null);
          // console.log('form valid: ', result);
        });
      },
      submit_search () {
        let _this = this;
        let loading = _this.$loading();
        this.$progress.start();

        function init() {
          var p = new Promise(function (resolve, reject) {
            Object.assign(_this.searchMap, _this.new_searchMap);
            _this.openSearchDialog = false;
            let parms = {};
            Object.assign(parms, _this.searchMap, {begin: 0});
            axios.post('/stock/out/select.mvc',Qs.stringify(parms))
              .then(function (response) {
                // console.log("select.mvc response = "+JSON.stringify(response));
                if (response.data.status == "0") {
                  Toast.error('没有数据！');
                }
                if (response.data.status == "2") {
                  Toast.error('查询异常！');
                }
                if (response.data.status == "3") {
                  Dialog.alert({
                    title: '请重新登录',
                    message: ''
                  }).then(() => {
                    _this.$router.replace("/Login");
                  });
                }
                if (response.data.status == "1") {
                  _this.list = response.data.data;
                  _this.total_count = response.data.total_count;
                  _this.search_total_count = response.data.search_total_count;
                  _this.$refs.lm.loadedAll = _this.search_total_count > _this.list.length;
                  Toast.success('OK！');
                }
                resolve();
              })
              .catch(function (error) {
                console.log(error);
              });
          });
          return p;
        }
        Promise
          .all([
            init()
          ])
          .then(function (results) {
            _this.$progress.done();
            loading.close();
          });
      },
      clear () {
        this.$refs.form.clear();
        this.form = {
          out_stock_type: '',
          out_stock_model:'',
          out_stock_production_date:'',
          out_stock_quantity:'',
          out_stock_date:'',
          out_stock_from:'',
          out_stock_platform:'',
          out_stock_unit_price:'',
          out_stock_total_price:''
        };
      },
      exportExcel_click: function() {
        let _this = this;
        let loading = _this.$loading();
        this.$progress.start();
        function init() {
          var p = new Promise(function (resolve, reject) {
            Object.assign(_this.searchMap, _this.new_searchMap);
            //this.new_searchMap = this.searchMap;
            _this.openSearchDialog = false;
            let parms = {};
            Object.assign(parms, _this.searchMap, {begin: 0});

            axios.post('/stock/out/ex.mvc', Qs.stringify(parms), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded', //请求的数据类型为form data格式
              },
              'responseType': 'blob'  //设置响应的数据类型为一个包含二进制数据的 Blob 对象，必须设置！！！
            }).then(function (response) {

              const blob = new Blob([response.data]);
              //获取后台文件名
              const fileName = decodeURIComponent(response.headers['content-disposition'].split('filename=')[1]);
              const linkNode = document.createElement('a');

              linkNode.download = fileName; //a标签的download属性规定下载文件的名称
              linkNode.style.display = 'none';
              linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
              document.body.appendChild(linkNode);
              linkNode.click();  //模拟在按钮上的一次鼠标单击

              URL.revokeObjectURL(linkNode.href); // 释放URL 对象
              document.body.removeChild(linkNode);

              resolve();

            }).catch(function (error) {
              console.error(error);
              _this.$progress.done();
              loading.close();
              Dialog.alert({
                title: '发生错误，请重新尝试',
                message: ''
              }).then(() => {

              });
            });
          });
          return p;
        }
        Promise
          .all([
            init()
          ])
          .then(function (results) {
            _this.$progress.done();
            loading.close();
          });
      }


    }
  };
</script>

<style scoped>

  .div1{
    display: flex;
    min-height: 100vh;
    flex-direction: column;
  }

  .mu-container{
    min-width:250px;
    width:300px;
  }

  .demo-loadmore-wrap {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .demo-loadmore-content {
    width: 100%;
    flex: 1;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
  .s1{
    font-size : 12px;
    font-weight: bold;
  }
  .s_key{
    font-size : 8px;
    color: rgba(0, 0, 0, .5)
  }
</style>



// WEBPACK FOOTER //
// src/components/out_stock/Idus_out_stock.vue